import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { toast } from 'react-toastify';
import '../../assets/style/style.css';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import { useParams, useNavigate } from 'react-router-dom';
import MDBox from "components/MDBox";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import Config from "../../config.js";
import { useEffect, useState, useContext } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import productNoImage from "../../assets/images/no-image.png";
import { handleErrors, checkPrivilege } from "common.js";
import AddressDetails from './AddressDetails';
import FulfillmentList from "./FulfillmentList.js";
import UnfulfillmentList from "./UnfulfillmentList.js";
import OrderSummary from "./OrderSummary.js";
import VendorDetails from "./VendorDetails.js";
import CalculationDetails from "./CalculationDetails.js";
import { PRIVILEGE } from "constants.js";

function OrderDetails() {
  const { orderID } =  useParams();  
  const navigate   = useNavigate();
  const { t }     = useTranslation();
  const adminType = localStorage.getItem("type");
  const BASE  = Config.BASE;
  const TOKEN = window.localStorage.getItem('token');
  const [isLoading, setIsLoading] = useState(false);
  const [pageContent, setPageContent] = useState({});
  const [unfulfilledTableData, setUnfulfilledTableData] = useState({});
  const [fulfilledTableData, setFulfilledTableData] = useState({}); 
  const [loading, setLoading] = useState(false);
  const [sendReminderIsLoading, setSendReminderIsLoading] = useState(false);
  

  useEffect(() => {
    loadOrderDetails();
  }, []);
   

  const handleSendReminder = () => {
    setSendReminderIsLoading(true);

    let requestPayLoad = { orderID: orderID };

    axios({      
          url     : BASE+"api/order/send-fulfillment-reminder",
          data    : requestPayLoad,
          method  : "POST",
          headers : {
            Authorization   : `Bearer ${TOKEN}`,
            function        : Config.FUNCTION_KEY
          },        
        }).then(function (response) 
        {
            const responseData           = response.data;
            const responseDataStatusCode = responseData.status;
            const responseMessage        = responseData.message;
            const responseStatusCode     = response.status;

            setSendReminderIsLoading(false);

            if(responseStatusCode === 200)
            {                
                if(responseDataStatusCode === 0)
                {
                    if(responseMessage)
                    toast.error(t(responseMessage));
                    else
                    toast.error(t('An unexpected error occurred while communicating with server'));
                }
                else if(responseDataStatusCode === 1)
                {
                  toast.success(t(responseMessage));
                }
            }  
            else 
            {
              toast.error(t('An unexpected error occurred while communicating with server'));
              return;            
            }        
        }).catch(function (error) {
          setSendReminderIsLoading(false);
          handleErrors(error, t, navigate);
        });
  }

  const loadOrderDetails = () => {
    setIsLoading(true);
    axios({      
          url     : BASE+"api/order/details/"+orderID,
          method  : "GET",
          headers : {
            Authorization   : `Bearer ${TOKEN}`,
            function        : Config.FUNCTION_KEY
          },        
        }).then(function (response) 
        {
            const responseData           = response.data;
            const responseDataStatusCode = responseData.status;
            const responseMessage        = responseData.message;
            const responseStatusCode     = response.status;

            if(responseStatusCode === 200)
            {
                setIsLoading(false);
                if(responseDataStatusCode === 0)
                {
                    if(responseMessage)
                    toast.error(t(responseMessage));
                    else
                    toast.error(t('An unexpected error occurred while communicating with server'));

                    const redirectTimeout = setTimeout(() => {          
                      clearTimeout(redirectTimeout);          
                      window.location.href = "/order/list";          
                    }, 3000);
                }
                else if(responseDataStatusCode === 1 && responseData && responseData.data)
                {
                    setPageContent(responseData.data);
                    const unfulfilledColumns  =  [
                      { label: `${t("Product ID")}`, field: "productId" },
                      { label: `${t("Image")}`, field: "image" },
                      { label: `${t("Product Name")}`, field: "title" },
                      { label: `${t("Unit Price")}`, field: "price" },
                      { label: `${t("Sku")}`,field: "sku" },
                      { label: `${t("Qty")}`, field: "quantity" },
                      { label: `${t("Qty Fulfilled")}`, field: "fulfilledQuantity" },
                      { label: `${t("Avl. Qty For Fulfill")}`, field: "quantityForFulfill" },
                      { label: `${t("Total")}`, field: "total" },
                    ];

                    const fulfilledColumns  =  [
                      { label: `${t("Product ID")}`, field: "productId" },
                      { label: `${t("Image")}`, field: "image" },
                      { label: `${t("Product Name")}`, field: "title" },
                      { label: `${t("Unit Price")}`, field: "price" },
                      { label: `${t("Sku")}`,field: "sku" },
                      { label: `${t("Qty Fulfilled")}`, field: "fulfilledQuantity" },
        	            { label: `${t("Shipment Status")}`, field: "shipmentStatus" },
                    ];

                    var unfulfilledRows          = [];
                    var unfulfilledProductsCount = 0; 
                    var allItemsFulfilled        = true;                    
                                   
                    responseData.data.orderItemList.map((item, index) => {

                        let productImage = item.productImage ? item.productImage : productNoImage;
                            unfulfilledProductsCount  = (item.fulfillmentStatus === 'unfulfilled') ? unfulfilledProductsCount+1 : unfulfilledProductsCount;
                                
                            if(allItemsFulfilled)
                            allItemsFulfilled = (item.fulfillmentStatus === 'unfulfilled' || item.fulfillmentStatus === 'partially_fulfilled') ? false : true;
                        
                        var tempData = {
                          "productId"  : "#"+item.productId,
                          "image"      : <Box className="productImageBox"><img className="productImage" src={productImage} alt={item.title}  /></Box>,
                          "title"      : <Box className="productTitleBox" title={item.title}>{item.title}</Box>,
                          "price"      : `₹${item.price.toFixed(2)}`,
                          "sku"        : item.sku ? item.sku : '-',
                          "quantity"   : item.quantity,
                          "fulfilledQuantity"   : item.fulfillableQuantity,
                          "quantityForFulfill" : (item.quantity - item.fulfillableQuantity),
                          "total"               : `₹${(item.price * item.quantity).toFixed(2)}`,
                        };
                        
                        unfulfilledRows.push(tempData);
                    });

                    var fulfillmentRowsList = [];
                    var fulfillmentItems    = responseData.data.fulfillmentDetails;
                    
                    fulfillmentItems.map((item, index) => {

                      var fulfilledRows = [];
                      item.fulfilledItems.map((items, itemIndex) => {
                        
                      let productImage      = items.productImage ? items.productImage : productNoImage;

                      var tempData = {
                        "productId"  : "#"+items.productId,
                        "image"      : <Box className="productImageBox"><img className="productImage" src={productImage} alt={items.title}  /></Box>,
                        "title"      : <Box className="productTitleBox" title={items.title}>{items.title}</Box>,
                        "price"      : `₹${items.price.toFixed(2)}`,
                        "sku"        : items.sku ? items.sku : '-',
                        "fulfilledQuantity" : items.fulfilledQuantity,
          	      	    "shipmentStatus" : item.shipmentStatus ?? "Manifested",
                      };
                      
                      fulfilledRows.push(tempData);

                      });

                      fulfillmentRowsList.push(fulfilledRows);
                  });

                  setUnfulfilledTableData({ unfulfilledColumns, unfulfilledRows, unfulfilledProductsCount: unfulfilledProductsCount, totalOrderedProducts: responseData.data.totalOrderedProducts });
                  setFulfilledTableData({ fulfilledColumns, fulfillmentRowsList, fulfillmentItems });
                }
            }  
            else 
            {
              toast.error(t('An unexpected error occurred while communicating with server'));
              return;            
            }        
        }).catch(function (error) {
          setIsLoading(false);
          handleErrors(error, t, navigate);
        });
  }

  return (
      <DashboardLayout>

        {loading ?
          <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}><CircularProgress color="inherit" /></Backdrop>
          :
        null}
        {Object.keys(pageContent).length > 0 ? 
        <>
        <DashboardNavbar pageTitle={t('Order')+' #'+pageContent.orderNumber} pageSubTitle={t('Here are details about order')}/>
        <MDBox my={3}>
          <Grid container spacing={2} my={1} sx={{ position: 'relative' }}>
              {isLoading ?  
                <Grid item xs={12}>
                  <Box className='circularLoadingCommonOuter'>
                      <CircularProgress size={30} className='circularLoadingCommon' />
                  </Box>
                </Grid>
              : <></>}

              {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && checkPrivilege("order", "write"))) ?
                <Box display="flex" flexDirection="row-reverse" className="sendReminderButton">
                  {(pageContent.orderStatus !== 'fulfilled' && pageContent.orderStatus !== 'rejected') ? 
                      <Button                     
                        variant="contained" 
                        sx={{color : '#FFFFFF', height : 45, margin: '10px'}} 
                        onClick={() => handleSendReminder() }
                        disabled={sendReminderIsLoading}
                        title={t("Send Fulfillment Reminder To Vendor")}  
                        disableRipple
                        >
                        {t("Send Reminder To Vendor")}  
                        {sendReminderIsLoading ? (                        
                          <Backdrop sx={{ color: '#FFFFFF', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={sendReminderIsLoading}>
                            <CircularProgress color="inherit" />
                          </Backdrop>
                        ) : null }
                      </Button>
                  : null}
                </Box>   
              : null} 


            
              <OrderSummary orderID = {orderID} pageContent = {pageContent} />       

              <UnfulfillmentList orderID = {orderID} orderStatus = {pageContent.orderStatus} unfulfilledTableData = {unfulfilledTableData} />     
                     
              <FulfillmentList orderID = {orderID}  fulfilledTableData = {fulfilledTableData} setLoading={setLoading} />  
                    
              <AddressDetails pageContent={pageContent} />     

              <CalculationDetails pageContent={pageContent} />   

              <VendorDetails pageContent={pageContent} />   
            
          </Grid>
        </MDBox>
        </>         
      : <></>}        
      </DashboardLayout>
  );
}
export default OrderDetails;
